// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ClickRadio_radioGroup__3YBm4 {
  --size: 1em;
  --border: 2px;
  border: none;
  padding: 0;
  margin: 0;
  display: flex;
  /* simple */
  /* button */
}
.ClickRadio_radioGroup__3YBm4 legend {
  font-weight: var(--bold);
  color: var(--foreground-color-1);
  margin: 0;
  padding: 0;
}
.ClickRadio_radioGroup__3YBm4 .ClickRadio_helpText__nPPfp {
  display: block;
  font-size: 0.75em;
  padding-bottom: 0.25em;
  color: var(--foreground-color-1);
  margin: 0 0 0.5em 0;
}
.ClickRadio_radioGroup__3YBm4 .ClickRadio_inputLabel__ceY93 {
  display: flex;
  align-items: center;
  --margin: 0.25em;
}
.ClickRadio_radioGroup__3YBm4 .ClickRadio_inputLabel__ceY93:not(:last-of-type) {
  margin-bottom: calc(0.5 * var(--margin));
}
.ClickRadio_radioGroup__3YBm4 input {
  font-size: 1em;
  position: relative;
  width: var(--size);
  height: var(--size);
  margin: 0;
}
.ClickRadio_radioGroup__3YBm4 input:checked:after {
  content: "";
  --distance: 0.25em;
  position: absolute;
  left: var(--distance);
  right: var(--distance);
  top: var(--distance);
  bottom: var(--distance);
  border-radius: 500px;
  background: var(--foreground-color-2);
}
.ClickRadio_radioGroup__3YBm4 input:before {
  position: absolute;
  content: "";
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  border-radius: 50%;
  background: var(--background-color-1);
  border: var(--border) solid var(--foreground-color-1);
}
.ClickRadio_radioGroup__3YBm4 input:focus {
  outline: none;
}
.ClickRadio_radioGroup__3YBm4 input.focus-visible + label:before {
  --focusWeight: 4px;
  --leftDistance: calc(var(--size) + var(--margin) + var(--focusWeight));
  content: "";
  position: absolute;
  top: calc(-0.5 * var(--focusWeight));
  bottom: calc(-0.5 * var(--focusWeight));
  right: calc(-1 * var(--focusWeight));
  left: calc(-1 * var(--leftDistance));
  border: 4px solid var(--foreground-color-2-alpha);
  border-top-left-radius: 100px;
  border-bottom-left-radius: 100px;
}
.ClickRadio_radioGroup__3YBm4 label {
  align-items: center;
  position: relative;
  color: var(--foreground-color-1);
}
.ClickRadio_radioGroup__3YBm4:not(.ClickRadio_isButton__9VPwU) label {
  margin-left: var(--margin);
}
.ClickRadio_radioGroup__3YBm4.ClickRadio_isButton__9VPwU {
  --height: 2.5rem;
  --borderRadius: calc(var(--height) / 2);
  --borderPadding: 0.2rem;
  --borderSize: 2px;
}
.ClickRadio_radioGroup__3YBm4.ClickRadio_isButton__9VPwU .ClickRadio_inputListWrap__6rj\\+5 {
  display: flex;
  flex-wrap: nowrap;
}
.ClickRadio_radioGroup__3YBm4.ClickRadio_isButton__9VPwU .ClickRadio_inputListWrap__6rj\\+5 .ClickRadio_inputLabel__ceY93 {
  display: inline-flex;
  justify-content: space-around;
  align-items: center;
  margin-right: 2px;
  padding: 0;
  height: var(--height);
}
.ClickRadio_radioGroup__3YBm4.ClickRadio_isButton__9VPwU .ClickRadio_inputListWrap__6rj\\+5 .ClickRadio_inputLabel__ceY93:first-of-type label {
  border-top-left-radius: var(--borderRadius);
  border-bottom-left-radius: var(--borderRadius);
}
.ClickRadio_radioGroup__3YBm4.ClickRadio_isButton__9VPwU .ClickRadio_inputListWrap__6rj\\+5 .ClickRadio_inputLabel__ceY93:last-of-type label {
  border-top-right-radius: var(--borderRadius);
  border-bottom-right-radius: var(--borderRadius);
  margin-right: 0;
}
.ClickRadio_radioGroup__3YBm4.ClickRadio_isButton__9VPwU .ClickRadio_inputListWrap__6rj\\+5 .ClickRadio_inputLabel__ceY93 input {
  position: absolute;
  left: -10000px;
}
.ClickRadio_radioGroup__3YBm4.ClickRadio_isButton__9VPwU .ClickRadio_inputListWrap__6rj\\+5 .ClickRadio_inputLabel__ceY93 input:checked + label {
  background: var(--foreground-color-2);
  border-color: var(--foreground-color-2);
}
.ClickRadio_radioGroup__3YBm4.ClickRadio_isButton__9VPwU .ClickRadio_inputListWrap__6rj\\+5 .ClickRadio_inputLabel__ceY93 input:not(:checked) + label {
  cursor: pointer;
}
.ClickRadio_radioGroup__3YBm4.ClickRadio_isButton__9VPwU .ClickRadio_inputListWrap__6rj\\+5 .ClickRadio_inputLabel__ceY93 input.focus-visible + label, .ClickRadio_radioGroup__3YBm4.ClickRadio_isButton__9VPwU .ClickRadio_inputListWrap__6rj\\+5 .ClickRadio_inputLabel__ceY93 input:hover + label {
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.5);
  z-index: 0;
}
.ClickRadio_radioGroup__3YBm4.ClickRadio_isButton__9VPwU .ClickRadio_inputListWrap__6rj\\+5 .ClickRadio_inputLabel__ceY93 input.focus-visible + label:before {
  --distance: calc(-3 * var(--borderSize));
  content: "";
  position: absolute;
  top: var(--distance);
  bottom: var(--distance);
  left: var(--distance);
  right: var(--distance);
  border: calc(2 * var(--borderSize)) solid var(--blueAlpha);
  height: auto;
  height: initial;
  width: auto;
  width: initial;
  border-radius: 0;
  border-radius: initial;
}
.ClickRadio_radioGroup__3YBm4.ClickRadio_isButton__9VPwU .ClickRadio_inputListWrap__6rj\\+5 .ClickRadio_inputLabel__ceY93:first-of-type input.focus-visible + label:before {
  border-bottom-left-radius: calc(2 * var(--borderRadius));
  border-top-left-radius: calc(2 * var(--borderRadius));
}
.ClickRadio_radioGroup__3YBm4.ClickRadio_isButton__9VPwU .ClickRadio_inputListWrap__6rj\\+5 .ClickRadio_inputLabel__ceY93:last-of-type input.focus-visible + label:before {
  border-bottom-right-radius: calc(2 * var(--borderRadius));
  border-top-right-radius: calc(2 * var(--borderRadius));
}
.ClickRadio_radioGroup__3YBm4.ClickRadio_isButton__9VPwU .ClickRadio_inputListWrap__6rj\\+5 label {
  display: flex;
  position: relative;
  z-index: 1;
  background: var(--foreground-color-1);
  color: var(--background-color-1);
  border: var(--borderSize) solid var(--foreground-color-1);
  padding: 0.25em;
  height: var(--height);
  font-weight: var(--bold);
  font-size: calc(var(--height) / 2.5);
  padding: 0 var(--borderRadius);
}
.ClickRadio_radioGroup__3YBm4.ClickRadio_isButton__9VPwU .ClickRadio_inputListWrap__6rj\\+5 label.ClickRadio_icon__ANyHI {
  padding: 0.75em;
}
.ClickRadio_radioGroup__3YBm4.ClickRadio_dark__IW-OG label,
.ClickRadio_radioGroup__3YBm4.ClickRadio_dark__IW-OG legend,
.ClickRadio_radioGroup__3YBm4.ClickRadio_dark__IW-OG .ClickRadio_helpText__nPPfp {
  color: var(--background-color-1);
}
.ClickRadio_radioGroup__3YBm4.ClickRadio_dark__IW-OG input:before {
  border: 1px solid var(--background-color-1);
}
.ClickRadio_radioGroup__3YBm4.ClickRadio_dark__IW-OG.ClickRadio_isButton__9VPwU label {
  background: var(--background-color-1);
  border: var(--borderSize) solid var(--background-color-1);
  color: var(--foreground-color-1);
}
.ClickRadio_radioGroup__3YBm4.ClickRadio_dark__IW-OG.ClickRadio_isButton__9VPwU input:checked + label {
  color: var(--background-color-1);
}

.ClickRadio_errorMessage__7QGsm {
  font-size: 0.75em;
  color: var(--danger);
  min-height: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/components/Form/ClickRadio.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,aAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EAcA,WAAA;EAkEA,WAAA;AA7EF;AAFE;EACE,wBAAA;EACA,gCAAA;EACA,SAAA;EACA,UAAA;AAIJ;AAFE;EACE,cAAA;EACA,iBAAA;EACA,sBAAA;EACA,gCAAA;EACA,mBAAA;AAIJ;AADE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AAGJ;AAFI;EACE,wCAAA;AAIN;AADE;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,SAAA;AAGJ;AAFI;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,sBAAA;EACA,oBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qCAAA;AAIN;AAFI;EACE,kBAAA;EACA,WAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,kBAAA;EACA,qCAAA;EACA,qDAAA;AAIN;AAFI;EACE,aAAA;AAIN;AADM;EACE,kBAAA;EACA,sEAAA;EACA,WAAA;EACA,kBAAA;EACA,oCAAA;EACA,uCAAA;EACA,oCAAA;EACA,oCAAA;EACA,iDAAA;EACA,6BAAA;EACA,gCAAA;AAGR;AACE;EACE,mBAAA;EACA,kBAAA;EACA,gCAAA;AACJ;AAEI;EACE,0BAAA;AAAN;AAIE;EACE,gBAAA;EACA,uCAAA;EACA,uBAAA;EACA,iBAAA;AAFJ;AAGI;EACE,aAAA;EACA,iBAAA;AADN;AAEM;EACE,oBAAA;EACA,6BAAA;EACA,mBAAA;EACA,iBAAA;EACA,UAAA;EACA,qBAAA;AAAR;AACQ;EACE,2CAAA;EACA,8CAAA;AACV;AACQ;EACE,4CAAA;EACA,+CAAA;EACA,eAAA;AACV;AACQ;EACE,kBAAA;EACA,cAAA;AACV;AAAU;EACE,qCAAA;EACA,uCAAA;AAEZ;AAAU;EACE,eAAA;AAEZ;AAAU;EAEE,0CAAA;EACA,UAAA;AACZ;AAEY;EACE,wCAAA;EAEA,WAAA;EACA,kBAAA;EACA,oBAAA;EACA,uBAAA;EACA,qBAAA;EACA,sBAAA;EAEA,0DAAA;EACA,YAAA;EAAA,eAAA;EACA,WAAA;EAAA,cAAA;EACA,gBAAA;EAAA,sBAAA;AAFd;AAMQ;EACE,wDAAA;EACA,qDAAA;AAJV;AAMQ;EACE,yDAAA;EACA,sDAAA;AAJV;AAOM;EACE,aAAA;EACA,kBAAA;EACA,UAAA;EACA,qCAAA;EACA,gCAAA;EACA,yDAAA;EACA,eAAA;EACA,qBAAA;EACA,wBAAA;EACA,oCAAA;EACA,8BAAA;AALR;AAMQ;EACE,eAAA;AAJV;AAUI;;;EAGE,gCAAA;AARN;AAUI;EACE,2CAAA;AARN;AAWM;EACE,qCAAA;EACA,yDAAA;EACA,gCAAA;AATR;AAYQ;EACE,gCAAA;AAVV;;AAiBA;EACE,iBAAA;EACA,oBAAA;EACA,gBAAA;AAdF","sourcesContent":[".radioGroup {\n  --size: 1em;\n  --border: 2px;\n  border: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  legend {\n    font-weight: var(--bold);\n    color: var(--foreground-color-1);\n    margin: 0;\n    padding: 0;\n  }\n  .helpText {\n    display: block;\n    font-size: 0.75em;\n    padding-bottom: 0.25em;\n    color: var(--foreground-color-1);\n    margin: 0 0 0.5em 0;\n  }\n  /* simple */\n  .inputLabel {\n    display: flex;\n    align-items: center;\n    --margin: 0.25em;\n    &:not(:last-of-type) {\n      margin-bottom: calc(0.5 * var(--margin));\n    }\n  }\n  input {\n    font-size: 1em;\n    position: relative;\n    width: var(--size);\n    height: var(--size);\n    margin: 0;\n    &:checked:after {\n      content: \"\";\n      --distance: 0.25em;\n      position: absolute;\n      left: var(--distance);\n      right: var(--distance);\n      top: var(--distance);\n      bottom: var(--distance);\n      border-radius: 500px;\n      background: var(--foreground-color-2);\n    }\n    &:before {\n      position: absolute;\n      content: \"\";\n      top: 0;\n      bottom: 0;\n      left: 0;\n      right: 0;\n      border-radius: 50%;\n      background: var(--background-color-1);\n      border: var(--border) solid var(--foreground-color-1);\n    }\n    &:focus {\n      outline: none;\n    }\n    &:global(.focus-visible) + label {\n      &:before {\n        --focusWeight: 4px;\n        --leftDistance: calc(var(--size) + var(--margin) + var(--focusWeight));\n        content: \"\";\n        position: absolute;\n        top: calc(-0.5 * var(--focusWeight));\n        bottom: calc(-0.5 * var(--focusWeight));\n        right: calc(-1 * var(--focusWeight));\n        left: calc(-1 * var(--leftDistance));\n        border: 4px solid var(--foreground-color-2-alpha);\n        border-top-left-radius: 100px;\n        border-bottom-left-radius: 100px;\n      }\n    }\n  }\n  label {\n    align-items: center;\n    position: relative;\n    color: var(--foreground-color-1);\n  }\n  &:not(.isButton) {\n    label {\n      margin-left: var(--margin);\n    }\n  }\n  /* button */\n  &.isButton {\n    --height: 2.5rem;\n    --borderRadius: calc(var(--height) / 2);\n    --borderPadding: 0.2rem;\n    --borderSize: 2px;\n    .inputListWrap {\n      display: flex;\n      flex-wrap: nowrap;\n      .inputLabel {\n        display: inline-flex;\n        justify-content: space-around;\n        align-items: center;\n        margin-right: 2px;\n        padding: 0;\n        height: var(--height);\n        &:first-of-type label {\n          border-top-left-radius: var(--borderRadius);\n          border-bottom-left-radius: var(--borderRadius);\n        }\n        &:last-of-type label {\n          border-top-right-radius: var(--borderRadius);\n          border-bottom-right-radius: var(--borderRadius);\n          margin-right: 0;\n        }\n        input {\n          position: absolute;\n          left: -10000px;\n          &:checked + label {\n            background: var(--foreground-color-2);\n            border-color: var(--foreground-color-2);\n          }\n          &:not(:checked) + label {\n            cursor: pointer;\n          }\n          &:global(.focus-visible) + label,\n          &:hover + label {\n            box-shadow: 1px 1px 5px rgba(black, 0.5);\n            z-index: 0;\n          }\n          &:global(.focus-visible) + label {\n            &:before {\n              --distance: calc(-3 * var(--borderSize));\n\n              content: \"\";\n              position: absolute;\n              top: var(--distance);\n              bottom: var(--distance);\n              left: var(--distance);\n              right: var(--distance);\n\n              border: calc(2 * var(--borderSize)) solid var(--blueAlpha);\n              height: unset;\n              width: unset;\n              border-radius: unset;\n            }\n          }\n        }\n        &:first-of-type input:global(.focus-visible) + label:before {\n          border-bottom-left-radius: calc(2 * var(--borderRadius));\n          border-top-left-radius: calc(2 * var(--borderRadius));\n        }\n        &:last-of-type input:global(.focus-visible) + label:before {\n          border-bottom-right-radius: calc(2 * var(--borderRadius));\n          border-top-right-radius: calc(2 * var(--borderRadius));\n        }\n      }\n      label {\n        display: flex;\n        position: relative;\n        z-index: 1;\n        background: var(--foreground-color-1);\n        color: var(--background-color-1);\n        border: var(--borderSize) solid var(--foreground-color-1);\n        padding: 0.25em;\n        height: var(--height);\n        font-weight: var(--bold);\n        font-size: calc(var(--height) / 2.5);\n        padding: 0 var(--borderRadius);\n        &.icon {\n          padding: 0.75em;\n        }\n      }\n    }\n  }\n  &.dark {\n    label,\n    legend,\n    .helpText {\n      color: var(--background-color-1);\n    }\n    input:before {\n      border: 1px solid var(--background-color-1);\n    }\n    &.isButton {\n      label {\n        background: var(--background-color-1);\n        border: var(--borderSize) solid var(--background-color-1);\n        color: var(--foreground-color-1);\n      }\n      input {\n        &:checked + label {\n          color: var(--background-color-1);\n        }\n      }\n    }\n  }\n}\n\n.errorMessage {\n  font-size: 0.75em;\n  color: var(--danger);\n  min-height: 1rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"radioGroup": `ClickRadio_radioGroup__3YBm4`,
	"helpText": `ClickRadio_helpText__nPPfp`,
	"inputLabel": `ClickRadio_inputLabel__ceY93`,
	"isButton": `ClickRadio_isButton__9VPwU`,
	"inputListWrap": `ClickRadio_inputListWrap__6rj+5`,
	"icon": `ClickRadio_icon__ANyHI`,
	"dark": `ClickRadio_dark__IW-OG`,
	"errorMessage": `ClickRadio_errorMessage__7QGsm`
};
export default ___CSS_LOADER_EXPORT___;
